import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const routeLabels: Record<string, string> = {
  '': 'Accueil',
  'messages': 'Messages',
  'alerts': 'Alertes de Sécurité',
  'watchlist': 'Liste de Surveillance',
  'scoring-rules': 'Règles de Scoring',
  'scenarios': 'Scénarios de Risque',
  'statistics': 'Statistiques',
  'guests': 'Invités',
  'documents': 'Validation Documents',
  'tax-config': 'Configuration Taxes',
  'operational': 'Dashboard Opérationnel',
  'admin': 'Administration',
  'hotels': 'Gestion Hôtels',
  'users': 'Gestion Utilisateurs',
  'settings': 'Paramètres Système',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Ne pas afficher le breadcrumb sur la page d'accueil
  if (pathnames.length === 0) {
    return null;
  }

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Accueil', path: '/' },
  ];

  let currentPath = '';
  pathnames.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const label = routeLabels[segment] || segment;
    
    // Le dernier élément n'a pas de lien
    if (index === pathnames.length - 1) {
      breadcrumbs.push({ label });
    } else {
      breadcrumbs.push({ label, path: currentPath });
    }
  });

  return (
    <nav className="bg-white border-b border-gray-200 px-4 py-3">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center space-x-2 text-sm">
          {breadcrumbs.map((crumb, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRightIcon className="h-4 w-4 text-gray-400 mx-2" />
              )}
              
              {crumb.path ? (
                <Link
                  to={crumb.path}
                  className="flex items-center text-blue-600 hover:text-blue-800 transition"
                >
                  {index === 0 && <HomeIcon className="h-4 w-4 mr-1" />}
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-gray-700 font-medium">
                  {crumb.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
